import { render, staticRenderFns } from "./AdwordsSummary.vue?vue&type=template&id=0217ceb8&scoped=true&"
import script from "./AdwordsSummary.vue?vue&type=script&lang=js&"
export * from "./AdwordsSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdwordsSummary.vue?vue&type=style&index=0&id=0217ceb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217ceb8",
  null
  
)

export default component.exports